module.exports = __webpack_public_path__ + "img/rocket-color.2729b2d5.svg";